// The operator's list filter is persisted to localStorage by
// pages/operator/requests/index.vue, and both new-request notifications read it
// from there: the sound and the tab badge alert only about the types, services
// and languages the operator's list is set to. A search term or a date range
// narrows a look through past requests, so the rest of the filter is left out.
//
// Shared on purpose. Two copies of this answer would drift apart, and then an
// operator hears a request that never appears on their screen.

// A rename here would leave both notifications reading a key nobody writes any
// more, and they would go quiet with nothing else breaking.
export const OPERATOR_REQUESTS_FILTER_KEY = 'operatorRequestsFilter';

// Null until the operator has ever touched a filter, which filters nothing out.
export const readOperatorRequestsFilter = () => {
  try {
    return JSON.parse(localStorage.getItem(OPERATOR_REQUESTS_FILTER_KEY));
  } catch (error) {
    // Throwing would take both watchers down with it and leave the operator
    // with no sound and no badge for as long as the unparseable value sat there.
    console.warn(error);
    return null;
  }
};

export default (request, filters) => {
  if (!filters) return true;

  // The states filter is intentionally ignored: a new request is always state 1,
  // so any states filter (the history view, for one) would silence every
  // notification.
  if (filters.types?.length && !filters.types.includes(request?.type_id)) return false;
  if (filters.services && filters.services !== request?.service_id) return false;
  if (filters.lang && filters.lang !== request?.client?.lang) return false;

  return true;
};
